import {getZodConstraint, parseWithZod} from '@conform-to/zod'
import {type LoaderFunctionArgs} from '@remix-run/node'
import {z} from 'zod'

import {FormSubmissionError, ValidationError} from '#domain/shared/errors'

export const getConstraint = getZodConstraint
export const parse = parseWithZod

export {z}

export async function parseParams<T extends z.AnyZodObject>(
  params: LoaderFunctionArgs['params'],
  schema: T,
) {
  const result = await schema.safeParseAsync(params)
  if (!result.success) {
    throw new ValidationError(result.error)
  }

  return result.data as z.infer<T>
}

// export async function parseFormData<T extends z.AnyZodObject>(request: Request, schema: T) {
//   const formData = await request.formData()
//   const result = schema.safeParse(formData)
//   if (!result.success) {
//     throw new ValidationError(result.error)
//   }

//   return result.data as z.infer<T>
// }

export async function parseFormSubmission<
  // Maybe this type could be simpler? I did it because I wanted to accept a union
  // of different schemas in "Update Proposal Status" action. If this is no longer
  // needed, let's simplify it.
  T extends z.AnyZodObject | z.ZodUnion<[z.AnyZodObject, ...z.ZodTypeAny[]]>,
>(request: Request, schema: T) {
  const formData = await request.formData()
  const submission = parse(formData, {schema})

  if (submission.status !== 'success') {
    throw new FormSubmissionError(submission.reply())
  }

  return submission.value as z.infer<T>
}
